export const borderTokens = {
  'border-radius-none': '0',
  'border-radius-sm': '4px',
  'border-radius-md': '6px',
  'border-radius-lg': '8px',
  'border-radius-xl': '12px',
  'border-radius-full': '9999px',
  'border-width-thin': '1px',
  'border-width-medium': '2px',
  'border-width-thick': '3px',
} as const;

export type BorderTokens = typeof borderTokens;
